import { useEffect } from 'react';

import { useQueryClient } from '@tanstack/react-query';

import { webSocketSubscriber } from '@/shared/api/web-socket-subscriber';

import { queryKeys } from '../api/session-charge.queries';
import { sessionChargeUpdatedNotificationSchema } from './session-charge.schemas';

export function useSessionChargeUpdates() {
    const queryClient = useQueryClient();

    useEffect(() => {
        const handler = () => {
            void queryClient.invalidateQueries({ queryKey: queryKeys.all });
        };

        webSocketSubscriber.subscribe(sessionChargeUpdatedNotificationSchema, handler);
        return () =>
            webSocketSubscriber.unsubscribe(sessionChargeUpdatedNotificationSchema, handler);
    }, []);
}
